import React from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { DialogHeading, DialogSubheading, Link, Separator, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./MissingCorporateInformationLink.module.scss";

export const MissingCorporateInformationLink = (props) => {
  const { accountNumber, companyName, missingCorporateInformation } = props;
  const { PRIVACY_POLICY } = getBootstrapData("urls");

  return (
    <>
      {missingCorporateInformation.some((missingInfo) => missingInfo === "LINK") && (
        <span className={styles.container}>
          <DialogHeading className={styles.heading}>
            {i18n("MissingCorporateInformationLink__HEADING")}
          </DialogHeading>
          <DialogSubheading>{i18n("MissingCorporateInformationLink__SUBHEADING")}</DialogSubheading>
          <Separator color={"missing-information-link-separator"} />
          <div className={styles.userInformation}>
            <div className={styles.label}>
              <Text>{i18n("MissingCorporateInformationLink__COMPANY")}</Text>
              <Text className={styles.value}>{companyName}</Text>
            </div>
            <div className={styles.label}>
              <Text>{i18n("MissingCorporateInformationLink__ACCOUNT_NUMBER")}</Text>
              <Text className={styles.value}>{accountNumber}</Text>
            </div>
          </div>
          <Separator color={"missing-information-link-separator"} />
          <Text className={styles.legal}>
            {i18n("MissingCorporateInformationLink__DISCLAIMER_PART_ONE")}
          </Text>
          <Text className={styles.legal}>
            {i18n("MissingCorporateInformationLink__DISCLAIMER_PART_TWO")}
            <Link {...getPrivacyPolicyLinkProps()}>
              {i18n("MissingCorporateInformationLink__PRIVACY_POLICY")}
            </Link>
            {i18n("MissingCorporateInformationLink__DISCLAIMER_PART_THREE")}
          </Text>
        </span>
      )}
    </>
  );

  function getPrivacyPolicyLinkProps() {
    return {
      external: false,
      href: PRIVACY_POLICY,
      newWindow: true,
      onClick: (event) => event.stopPropagation(),
    };
  }
};
